import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Usuario/addUsuario`, method: 'POST', body: values, token: token})
}